'use memo';

import { useAuthStore } from '@/lib/auth';
import { EnvMode, getMode } from '@/lib/env/feature-flag';

/**
 * STG で AI チャット機能を許可する organizationId。
 * ローカル dev では全 organization で表示し、STG ではこの組織のみに限定する。
 */
const AI_CHAT_ALLOWED_ORGANIZATION_ID = 'OCIL22wq6lK';

/**
 * グローバル AI チャット機能が有効な環境かどうか（FAB / パネルの描画可否）。
 *
 * FAB は閉じているとき画面右下に固定表示される。下部固定要素（sticky なフォーム
 * アクション等）は、この判定が true のとき重なり回避の余白を付ける。
 * demo / production では機能自体が無効のため、余白を常時確保するとレイアウトがずれる。
 *
 * なおチャットパネル開閉中は FAB 自体は非描画だが、パネルが右下を占有するため
 * 余白を残しても実害は小さい。環境単位の判定に留め、開閉状態までは見ない。
 */
export const useAiChatFabVisible = (): boolean => {
  const organizationId = useAuthStore(state => state.session?.organization?.organizationId);
  return import.meta.env.DEV || getMode() === EnvMode.development || getMode() === EnvMode.staging && organizationId === AI_CHAT_ALLOWED_ORGANIZATION_ID;
};